import React from 'react';
import PropTypes from 'prop-types';
import GeneralDialogLayout from '@Containers/Dialogs/GeneralDialogLayout';

import './HeatmapLegendDialog.custom.scss';
import './HeatmapLegendDialog.theme.scss';

function HeatmapLegendDialog({ closed, selfClose }) {
  return (
    <GeneralDialogLayout
      closed={closed}
      selfClose={selfClose}
      className="heatmap-legend-dialog"
      headerClassName="heatmap-legend-dialog__header"
      contentClassName="heatmap-legend-dialog__content"
      size="sm"
      movable
      header={<h3>Legend</h3>}>
      <div className="heatmap-legend-dialog-content">
        <div className="heatmap-legend-dialog-content__left-column">
          <div className="heatmap-legend-dialog-content__high">High</div>
          <div className="heatmap-legend-dialog-content__low">Low</div>
        </div>
        <div className="heatmap-legend-dialog-content__color-map-column">
          <div className="heatmap-legend-dialog-content__gradient">
            <i className="heatmap-legend-dialog-content__n">n</i>
          </div>
          <div className="heatmap-legend-dialog-content__gray" />
          <div className="heatmap-legend-dialog-content__white" />
        </div>
        <div className="heatmap-legend-dialog-content__right-column">
          <div className="heatmap-legend-dialog-content__quantative-data">Quantitative data</div>
          <div className="heatmap-legend-dialog-content__formula">
            <i className="heatmap-legend-dialog-content__n">n</i> = pX value
          </div>
          <div className="heatmap-legend-dialog-content__note">Colour indicates bioactivity potency based on pX value</div>
          <div className="heatmap-legend-dialog-content__qualitative-data">pX not determined</div>
          <div className="heatmap-legend-dialog-content__no-data">No data</div>
        </div>
      </div>
    </GeneralDialogLayout>
  );
}

HeatmapLegendDialog.propTypes = {
  closed: PropTypes.bool,
  selfClose: PropTypes.func,
};

export default HeatmapLegendDialog;
